import { useCallback } from 'react'

import { useApiLazy, UseApiLazyState } from '../../../hooks/useApiLazy'

export interface DispensaryTestKitRequestPostBody {
  data: {
    dispensarySlug: string
    sku: string
  }
}

export interface DispensaryTestKitRequest {
  dispensarySlug: string
  sku: string
}

export type UseDispensaryTestKitRequest = [
  requestDispensaryTestKit: (request: DispensaryTestKitRequest) => Promise<void>,
  state: UseApiLazyState<DispensaryTestKitRequest>,
]

export const useDispensaryTestKitRequest = (): UseDispensaryTestKitRequest => {
  const [doApiRequest, state] = useApiLazy<
    DispensaryTestKitRequest,
    DispensaryTestKitRequestPostBody
  >()

  const requestDispensaryTestKit = useCallback(
    async ({ dispensarySlug, sku }: DispensaryTestKitRequest): Promise<void> => {
      const result = await doApiRequest('/api/dispensaries/test-kit-requests', {
        loginRequired: true,
        method: 'POST',
        body: {
          data: {
            dispensarySlug,
            sku,
          },
        },
      })
      if (result._tag === 'Left') {
        throw result.error
      }
    },
    [doApiRequest],
  )

  return [requestDispensaryTestKit, state]
}
